/**
 * utils/format.js
 * Convertit le texte brut du LLM en HTML sécurisé.
 */
export function formatTextToHTML(text) {
  if (!text) return "";
  text = text.replace(/^(\*\*)?(Résumé|Summary|Zusammenfassung)(\*\*)?\s*:/i, "").trim();
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>")
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g,     "<b>$1</b>")
    .replace(/(<br>|^)- /g,    "$1&bull; ");
}